import { gql } from '@apollo/client';

export const CREATE_SURROUNDING_INFORMATION_MUTATION = gql`
  mutation CreateSurroundingInformation($data: SurroundingInformationInput!) {
    createSurroundingInformation(input: { data: $data }) {
      surroundingInformation {
        id
        locale
        localizations {
          locale
          id
        }
      }
    }
  }
`;
